module.exports = __webpack_public_path__ + "static/media/barcodeImage_qr.27843e15.svg";